import React from 'react';
import { DealFlowNavbar } from './DealFlowNavbar';
import { DealFlowFooter } from './DealFlowFooter';
export function DealFlowLayout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex flex-col min-h-screen bg-charcoal-dark text-white font-sans selection:bg-gold selection:text-charcoal-dark" data-id="element-246">
      <DealFlowNavbar data-id="element-247" />
      <main className="flex-grow" data-id="element-248">{children}</main>
      <DealFlowFooter data-id="element-249" />
    </div>;
}